import React, { useState, useEffect } from "react";
import Navigation from "../Navigation/Navigation";
import chapters from "../../utils/chapters";
import Sun from "../Sun";
import ProgressModal from "../ProgressModal/ProgressModal";

function MainComponent(props) {
  let setTheProgress = "intro";

  //check if progress is stored locally
  if (localStorage.getItem("chapterProgress")) {
    setTheProgress = localStorage.getItem("chapterProgress");
  }
  let [sunState, setSunState] = useState(false);
  let [chapterIndicatorLabel, setChapterIndicator] = useState("Velkommen");
  let [progress, setProgress] = useState(setTheProgress);
  let [modalState, setModalState] = useState(false);

  const [modal, setModal] = useState([
    {
      progress: "intro",
      next: "one",
      title: "Introduksjon",
      show: true,
      text: "Dere er helt kongle!",
      text2:
        "Gå til kapittel 1 og bli kjent med skrukketrollet og vennene hans",
      active: false,
      sun: "green-fill",
    },
    {
      progress: "one",
      next: "two",
      show: true,
      text: "Tusen hakk for at dere kilde\u00ADsorterer!",
      text2: "Gå til kapittel 2 og bli kjent med hakk hakk hakkespetten",
      title: "kapittel 1",
      active: false,
      sun: "green-fill",
    },
    {
      progress: "two",
      next: "three",
      show: true,
      text: "Tre ganger tre, hurra for dere!",
      text2: "Gå til kapittel 3 og bli kjent med trærne i skogen",
      title: "kapittel 2",
      active: false,
      sun: "green",
    },
    {
      progress: "three",
      next: "four",
      show: true,
      text: "Wow, dere er litt av noen arbeidsmaur!",
      text2: "Gå til kapittel 4 og bli kjent med den sterkeste i skogen",
      title: "kapittel 3",
      active: false,
      sun: "red",
    },
    {
      progress: "four",
      next: "five",
      show: true,
      text: "Tommel sopp for dere!",
      text2: "Gå til kapittel 5 og bli kjente med soppen i skogen",
      title: "kapittel 4",
      active: false,
      sun: "red",
    },
    {
      progress: "five",
      next: "six",
      show: true,
      text: "Dere er rå. det er sikkert og kvist!",
      text2: "Gå til kapittel 6 og bli kjente skolopenderen i skogen",
      title: "kapittel 5",
      active: false,
      sun: "red-fill",
    },
    {
      progress: "six",
      unlockDate: new Date("2020-10-01"),
      show: true,
      text: "Tusen hakk for at du kilde\u00ADsorterer!",
      title: "kapittel 6",
      active: false,
    },
    {
      progress: "outro",
      title: "Avslutning",
      show: false,
      active: false,
    },
  ]);

  const chapterTransition = (chapter) => {
    modal.map((item) => {
      if (chapter === item.progress) {
        setChapterIndicator(item.title);
        setSunState(item.sun);
      }
      return null;
    });
  }

  const handleModal = (progress) => {
    setModal(
      modal.map((item) => {
        //show progress modal
        if (item.progress === progress && item.show && !modalState) {
          item.active = true;
          setModalState(modalState === false ? true : false);
          //hide progress modal and proceed chapter progress
        } else if (item.progress === progress && item.show && modalState) {
          setModalState(modalState === false ? true : false);
          setProgress(progress);
          localStorage.setItem("chapterProgress", progress);
          //no progress modal and proceed with chapter progress
        } else if (item.progress === progress) {
          item.active = true;
          setProgress(progress);
          localStorage.setItem("chapterProgress", progress);
        } else {
          item.active = false;
        }
        return item;
      })
    );
  };

  const contentRenderer = () => {
    const array = chapters[progress];
    return array.map((chapter, i) => {
      const TagName = chapter;
      return (
        <TagName
          handleModal={handleModal}
          chapterTransition={chapterTransition}
          key={chapter}      
        />
      );
    });
  };

  const modalContentRenderer = () => {
    if (modalState) {
      return (
        <ProgressModal
          modal={modal}
          handleModal={handleModal}
          progress={progress}
        ></ProgressModal>
      );
    }
  }

  const scrollToActive = (chapter) => {
    let thisChapter = document.getElementsByClassName("chapter-" + chapter)[0];
    thisChapter.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }
  
  useEffect(() => {
    scrollToActive(progress);
  }, [progress]);
  return (
    <>
      <div className={"viewer " + progress}>
        <div className="scroll-wrapper">
          <Navigation scrollToActive={scrollToActive}></Navigation>
          <div className="chapter-indicator">{chapterIndicatorLabel}</div>
          <Sun sunState={sunState} />
          {contentRenderer()}
          {modalContentRenderer()}
        </div>
      </div>
    </>
  );
}

export default MainComponent;
